export default __webpack_public_path__ + "static/media/servicePreview.9ed388fa.png";